import { IArticleDetail, IArticleList } from '@/interfaces/article';
import { getMethod } from '@/services/apis/http-server';
export const getArticles = async (
  body: Record<string, any>,
): Promise<IArticleList | undefined> => {
  try {
    const response = await getMethod(`client/articles/list`, body);
    return response.data as IArticleList;
  } catch (error) {
    console.error('Error posting data: ', error);
  }
};

export const getArticleDetail = async (
  id: string,
): Promise<IArticleDetail | undefined> => {
  try {
    const response = await getMethod(`client/articles/${id}`);
    return response?.data;
  } catch (error) {
    console.error('Error posting data: ', error);
  }
};

export const getTopArticles = async () => {
  try {
    const response = await getMethod(`client/articles/prevailing/list`);
    return response.data as IArticleList;
  } catch (error) {
    console.error('Error posting data: ', error);
  }
};
